import axios from 'axios'
import router from "../../router/router";

const state = {
  token: null,
  user: null,
  initialRoute: null
}

const getters = {
  authCheck(state) {
    return state.token !== null;
  },
  token(state) {
    return state.token
  },
  isAdmin(state) {
     return state.user ? state.user.role.id === 1 : false
  },
  isManager(state) {
     return state.user ? state.user.role.id === 2 : false
  },
  isSimple(state) {
    return state.user ? state.user.role.id === 3 : false
  },
  user(state) {
    return state.user
  },
  initialRoute(state) {
    return state.initialRoute
  }
}

const mutations = {

  storeToken (state, token) {
    state.token = token
  },

  storeUser (state, user) {
    state.user = user
  },

  clearAuthData (state) {
    state.token = null
    state.user = null
  },

  setInitialRoute (state, route) {
    if (state.initialRoute === null)
      state.initialRoute = route
  }
}

const actions = {

  setUser({commit}, user) {
    commit('storeUser', user)
  },

  tryToRefreshToken({commit, dispatch}) {
    axios.post('/refresh')
      .then(res => {
        const token = res.data.access_token
        const expiresIn = res.data.expires_in

        if (token) {
          commit('storeToken', token)
          dispatch('fetchUser')
          dispatch('storeTokenInCookie', { token, expiresIn })
        } else {
          dispatch('clearUser')
        }
      })
      .catch(error => dispatch('clearUser'))
  },

  fetchUser({commit}) {
    axios.get('/me')
      .then(res => commit('storeUser', res.data.data))
      .catch(error => {})
  },

  storeTokenInCookie({}, tokenData) {
    const expirationDate = new Date((new Date()).getTime() + tokenData.expiresIn * 1000)
    const token = tokenData.token

    document.cookie = "token=" + token + ";expires=" + expirationDate + ";"
  },

  deleteCookie() {
    document.cookie = "token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;"
  },

  tryToLoginFromCookie({commit, dispatch}) {
    const cookies = document.cookie
    const token = /token=(.*);?/.exec(cookies)

    if (token) {
      commit('storeToken', token[1])
      dispatch('tryToRefreshToken')
    }
  },

  login ({commit, dispatch}, data) {
    const token = data.access_token
    const expiresIn = data.expires_in

    commit('storeToken', token)
    dispatch('storeTokenInCookie', { token, expiresIn })
    dispatch('fetchUser')
    dispatch('setTimerForTokenRefresh', expiresIn)

    router.replace({ name: 'agenda.index' })
  },

  clearUser({commit, dispatch}) {
    commit('clearAuthData')
    dispatch('deleteCookie')
  },

  logout({dispatch}) {
    dispatch('clearUser')
    router.replace({ name: 'login' })
  },

  setTimerForTokenRefresh({dispatch}, expiresIn) {
    setInterval(() => {
      dispatch('tryToRefreshToken')
    }, expiresIn * 1000 - 60 * 1000) // 1 minute earlier than expires
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js